/**
 * HT PLP Revamp
 * Image gallery only — dots, arrows, touch swipe
 * Swatch hover image swap intentionally excluded (incompatible with slide architecture)
 */

(function () {
  'use strict';

  function initGallery(card) {
    var wrapper = card.querySelector('[data-gallery-wrapper]');
    if (!wrapper) return;

    var slides = wrapper.querySelectorAll('[data-slide]');
    var dots   = wrapper.querySelectorAll('[data-dot]');
    var prev   = wrapper.querySelector('[data-gallery-prev]');
    var next   = wrapper.querySelector('[data-gallery-next]');

    if (slides.length <= 1) return;

    var currentIndex = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides[currentIndex].classList.remove('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');

      currentIndex = index;

      slides[currentIndex].classList.add('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(parseInt(dot.getAttribute('data-dot'), 10));
      });
    });

    // Touch swipe
    var touchStartX = 0;
    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    wrapper.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });
  }

  function initAll(root) {
    var cards = (root || document).querySelectorAll('.ht-pcard');
    cards.forEach(function (card) { initGallery(card); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () { initAll(); });

  // Re-init for AJAX pagination / infinite scroll
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('ht-pcard')) {
          initGallery(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.ht-pcard').forEach(function (c) { initGallery(c); });
        }
      });
    });
  });

  function attachObserver() {
    var list = document.getElementById('ProductsList');
    if (list) mo.observe(list, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }

})();
